import axios from 'axios';
import React, { useEffect, useState, useCallback } from 'react';
import { Container, Row, Col } from 'react-bootstrap';

import sectionTopBg from '../../assets/images/section-top-green.webp';
import Skeleton from '../../components/skeleton/Skeleton';

import { API_ENDPOINTS } from '../../utils/config';

const ExpertiseSection = () => {

    const [expertises, setExpertises] = useState([]); 
    const [isLoading, setIsLoading] = useState(true); 

    const apiEndpoint = API_ENDPOINTS.EXPERTISE_ENDPOINT;

    const fetchExpertises = useCallback( async () => {
        setIsLoading( true );
        try {
            const response = await axios.get( apiEndpoint, {
                headers:{ 'Content-type': 'application/json; charset=UTF-8' }
            })
            setExpertises( response.data || [] );
        } catch (error) {
            console.error( 'Failed to fetch expertises:', error );
            setExpertises( [] );
        } finally {
            setIsLoading( false );
        }
    }, [apiEndpoint] );

    useEffect(() => {
        fetchExpertises();
        // eslint-disable-next-line	
    },[fetchExpertises])

    if ( isLoading ) {
        return (
            <section id="services" className="section bg-light">
                <Container>
                    <Row className="gy-5 mt-5">
                        <Skeleton type="expertise" />
                    </Row>
                </Container>
            </section>
        );
    }

    if ( !expertises.length ) {
        return (
            <section id="services" className="section bg-light">
                <Container className="py-5 text-center text-white">
                    <p>No expertise data available.</p>
                </Container>
            </section>
        );
    }

    return (
        <section id="services" className="section bg-light">
            <div className="section-decoration top" style={{ backgroundImage: `url(${ sectionTopBg })`, height: '35px' }}></div>
            <Container> 
                <div className="position-relative d-flex text-center">
                    <h2 className="text-22 text-light opacity-4 text-uppercase fw-600 w-100 mb-0 font-primary wow fadeInUp">What I Do?</h2>
                    <p className="text-10 text-dark fw-600 position-absolute w-100 align-self-center font-secondary lh-base mb-0 wow fadeInUp">Expertise and Knowledge</p>   
                </div>        
                <Row className="gy-5 mt-2">
                    { expertises.map(({ id, icon_url, title, excerpt }) => (                        
                        <Col lg={4} sm={6} className="wow fadeInUp" key={ id }>
                            <div className="featured-box ps-3 pe-3">
                                <div className="featured-box-icon"><img src={ icon_url } alt="" height={ '70px' }/></div>
                                <h3 className="text-5 fw-500 mb-3">{ title }</h3>
                                <p className="text-3 mb-0 text-muted">{ excerpt }</p>
                            </div>
                        </Col>
                    )) }                   
                </Row>
            </Container>
        </section>
    );
}

export default ExpertiseSection;
